module.exports = __webpack_public_path__ + "img/icon63.9e3ae327.png";